import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class VenueSetup extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Venue Setup </h2>

                <br/>
                <p className='text-danger'>
                These settings are admin-only permissions
                </p>

                <h6> Overview:  </h6>
                <p className='text-primary'>
                The venue settings are used to change general, shipping, and billing information for the hotel. These settings effect all users in the system.
                They accessed by clicking the tabs.  NOTE:  Clicking away from the screen will not save the settings.  Clcik UPDATE at the bottom 
                to save all your changes.  

                </p>
               

                <h6> General Settings:  </h6>
                <p className='text-primary'> Change the name, main phone number and icon are used for all shipping emails and form letters. Test account should be unchecked if not testing the system.  This
                is set by the BOUNTE admin and support personell.  The name and phone number are required to save.   </p>
                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/venue1.png'  alt=''/> 
              
                   
                </div>

                <br/>


                <hr/>

                <h6> Shipping Settings:  </h6>
                <p className='text-primary'> The address used for calculating and displaying the return address (ship from ) for each shipping label.  Its important to fill in all the fields.  
                Missing fields will result in incorrect shipping label production.  The Shipping phone is required.  Most carriers require this phone number when shipping.     </p>
                <br/>
                <p className='text-primary'> 
                <b>Personalized email settings</b> are utilized when BOUNTE sends emails to guest for shipping information.  This can be changed at anytime.   You can use HTML tags to
                custimize the style of the message, though it is not required.   

                The default label output is the format the shipping label will be created.  If using a 4X6 thermal printer labels, the PDF shipping label will be generated using this
                label size. NOTE: If printing an international label, it should be set to 8.5 X 11. NOTE: <b> The shipping wizard will auto-change the format if the international checkbox is selected.</b>
                </p>
                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/venue2.png'  alt=''/> 
              
                   
                </div>

                <br/>
                <hr/>


            <h6> Shipping Carrier Settings:  </h6>
                <p className='text-primary'> Each fo the hotel's carreirs will be setup with BOUNTE during the setup process. This screen will be "read-only" and only display the current
                carriers supported by your hotel.  Each carrier will have a unique ID and displayed in the textbox.  This screen will display a ID for each supported carrier
                configured during initial setup.  If you need another carrier added or changed,  email support@bounte.net   </p>
                <br/><br/><br/>

                <div className="text-center">
                        <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/venue3.png'  alt=''/> 
              
                   
                </div>
                <br/>


                <hr/>
               <h6>
                 FORM LETTER SETTINGS:  </h6>
                    <p className='text-primary'> An optional letter can be printing alongside a label.  This screen will enable each hotel to customize the contents of the letter.
                     Enter the contents of the letter in the field provided.  This will be prefilled udrring account setup and can be changed at any time.  The
                     field will support HTML to provide added formatting and style.  This can be requested from BOUNTE if needed.  There are two "macro fields" provided called
                     "[firstName]" and "lastName]" which will be auto-filled from the return wizard or claim.  <br/>  The standard size of print out is 8.5 X 11</p>
                    <br/><br/><br/>

                    <div className="text-center">
                            <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/venue4.png'  alt=''/> 
                
                    
                    </div>
                    <br/>

                 <hr/>
               <h6>
               VENUE BILLING ADDRESS:  </h6>
                    <p className='text-primary'> This screen details the hotel's billing information.  Enter a billing address into the text field provided.  This will be utilized
                    by BOUNTE for any checks to be sent to the hotel. This can be the same as your shipping address. 
                    <br/>
                    <b> Shipping &amp; Fee Settings: </b> <br/>
                    1) Enter the Shipping Fee in USD for BOUNTE to collect in total for the handeling fee.
                    <br/>
                    2) Etner the International fee to collect from guests.
                    <br/>
                    3) Enter the % BOUNTE.  This is the percentage to split with BOUNTE.  Its calculated by taking % of the handling fee whan the shipping labels are purchased.
                    Important: Changing this will not effect past label  purchases and requires BOUNTE authorization. 
                    </p>
                    <br/><br/><br/>

                    <div className="text-center">
                            <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/venue5.png'  alt=''/> 
                
                    
                    </div>
                    <br/>
                    <hr/>
               <h6>
               PUBLISH SETTINGS:  </h6>
                    <p className='text-primary'> This screen displays the javaScript code necessary to add the hotel's lost and found list
                    online.  
                    <br/>
                    Copy the javaScript code and paste into the HTML page for the hotel's website.  NOTE:  the parameters are configurable.  Each hotel has a specific ID
                    </p>
                    <br/><br/><br/>

                    <div className="text-center">
                            <img className='text-center' style={{maxWidth:800, width:"100%",maxHeight:800, height:"100%"}} src='./images/venue6.png'  alt=''/> 
                
                    
                    </div>
                    <br/>

            </div>
        )
       


    }

}
export default withRouter(VenueSetup);
